import React from 'react';
import { Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import { getStatusObject } from './activityStatus.utils';
import './activityStatus.styles.less';


const ActivityStatus = (props) => {
  const statusData = getStatusObject(props.name);
  
  return (
    <div className={classNames('activities-status-component', {active: statusData.name === 'Active'})}>
      <div className="icon-container">
        <Icon size="large" className={statusData.icon} />
      </div>
      <span className="activities-status-component-name">
        { props.message ? props.message : props.intl.formatMessage({ id: statusData.messageId })}
      </span>
    </div>
  );
};

ActivityStatus.propTypes = {
  name: PropTypes.string.isRequired,
  message: PropTypes.string,
  intl: PropTypes.object.isRequired
};

export default injectIntl(ActivityStatus);
